import cx from 'classnames'
import React, {Component} from 'react'

import './styles.css'

class Input extends Component {
  onChange = event => {
    this.props.onChange(event.target.value)
  }

  render() {
    const {className, value, ...rest} = this.props
    return (
      <input
        {...rest}
        value={value}
        className={cx("input", className)}
        onChange={this.onChange}
      />
    )
  }
}

export default Input



// WEBPACK FOOTER //
// ./src/components/Input/index.js